import { render, staticRenderFns } from "./projectIntegration.vue?vue&type=template&id=0605dd10"
import script from "./projectIntegration.js?vue&type=script&lang=js&external"
export * from "./projectIntegration.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports